import moment from 'moment';

const formatDateTime = function (date, format = 'L') {
  if (!date) {
    return null;
  }
  return moment.parseZone(date).locale(process.env.VUE_APP_I18N_LOCALE).format(format);
};

const getDateTime = function (date, time = '00:00') {
  return moment(date + ' ' + time)
    .locale(process.env.VUE_APP_I18N_LOCALE)
    .format();
};

const getDateTimeString = function (dateTime) {
  return moment(dateTime)
    .locale(process.env.VUE_APP_I18N_LOCALE)
    .format();
};

const getDateObject = function (dateTime) {
  return moment.parseZone(dateTime).locale(process.env.VUE_APP_I18N_LOCALE).toDate();
};

const diffDateTime = function (startDateTime, endDateTime) {
  let diff = getDateObject(endDateTime) - getDateObject(startDateTime);
  return moment.duration(diff);
};

const isoToDateObject = (isoString) => {
  return moment(isoString).toDate();
};

const getISOWeekNumber = (date) => {
  return moment(date).isoWeek();
};

const date14DaysAgo = () => {
  const date = new Date();
  date.setDate(date.getDate() - 14);
  return date.toISOString().split('T')[0];
};
const date30DaysAgo = () => {
  const date = new Date();
  date.setDate(date.getDate() - 30);
  return date.toISOString().split('T')[0];
};
const date3MonthsAgo = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 3);
  return date.toISOString().split('T')[0];
};
const date6MonthsAgo = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 6);
  return date.toISOString().split('T')[0];
};
const dateThisYearStart = () => {
  const date = new Date();
  date.setMonth(0);
  date.setDate(1);
  return date.toISOString().split('T')[0];
};
const dateLastYearStart = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 1);
  date.setMonth(0);
  date.setDate(1);
  return date.toISOString().split('T')[0];
};
const dateLastYearEnd = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 1);
  date.setMonth(11);
  date.setDate(31);
  return date.toISOString().split('T')[0];
};

export {
  formatDateTime,
  getDateTime,
  getDateTimeString,
  getDateObject,
  diffDateTime,
  isoToDateObject,
  getISOWeekNumber,
  date14DaysAgo,
  date30DaysAgo,
  date3MonthsAgo,
  date6MonthsAgo,
  dateThisYearStart,
  dateLastYearStart,
  dateLastYearEnd
};
